"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var SearchDiscover = function SearchDiscover() {
  return _react2.default.createElement(
    "div",
    { className: "quiver-intro-modal__item__icon" },
    _react2.default.createElement(
      "svg",
      {
        width: "37px",
        height: "34px",
        viewBox: "0 0 37 34",
        className: "quiver-intro-modal__search--discover--icon"
      },
      _react2.default.createElement(
        "defs",
        null,
        _react2.default.createElement("path", {
          d: "M32.5153369,20.8355241 C32.5199927,18.444703 30.5800621,16.5001272 \n            28.1823078,16.4923799 C25.7845536,16.4830831 23.8291035,18.4276589 \n            23.8244477,20.8262273 C23.8213438,23.2154989 25.7612744,25.1600747 \n            28.1590287,25.1693715 C30.5567829,25.1786683 32.512233,23.232543 \n            32.5153369,20.8355241 Z M35,21.2275382 C34.9751689,21.4150232 \n            34.9549936,21.6025082 34.9286106,21.7899932 C34.747033,23.0683 \n            34.2410991,24.2071551 33.4123608,25.1941629 C32.4967135,26.2880837 \n            31.3529304,27.0364742 29.9716998,27.4021474 C28.0457367,27.9119207 \n            26.2284097,27.6361163 24.5290305,26.5964268 C24.457641,26.5530418 \n            24.3893555,26.5065579 24.319518,26.463173 C24.3164141,26.4616235 \n            24.3117583,26.460074 24.3086544,26.460074 L19.761457,31 C19.1655103,30.4034568 \n            18.5835311,29.8224083 18,29.2413597 C19.5069381,27.7352819 21.0231879,26.2230062 \n            22.5440935,24.7029832 C22.5037429,24.6379058 22.4680482,24.5790262 \n            22.4308015,24.5216961 C21.6455176,23.2991699 21.2854665,21.9588846 \n            21.3506482,20.5101369 C21.4763557,17.7009609 23.3154099,15.2249193 \n            26.0173453,14.3727148 C28.7006573,13.5251587 31.084444,14.1309986 \n            33.0849005,16.1096626 C34.104528,17.1199123 34.6880592,18.3703288 \n            34.9192989,19.7849883 C34.9534417,20.0003637 34.9736169,20.2188379 \n            35,20.4342132 L35,21.2275382 Z",
          id: "path-1"
        })
      ),
      _react2.default.createElement(
        "g",
        {
          id: "onboarding-modal",
          stroke: "none",
          strokeWidth: "1",
          fill: "none",
          fillRule: "evenodd",
          transform: "translate(-55.000000, -149.000000)"
        },
        _react2.default.createElement(
          "g",
          { id: "Group-8" },
          _react2.default.createElement(
            "g",
            {
              id: "Group-7",
              transform: "translate(55.000000, 149.000000)"
            },
            _react2.default.createElement("rect", {
              id: "Rectangle-11",
              fill: "#F2F7F9",
              x: "0",
              y: "0",
              width: "32",
              height: "24"
            }),
            _react2.default.createElement("rect", {
              id: "Rectangle-3",
              fillOpacity: "0.5",
              fill: "#96A9B2",
              x: "8",
              y: "6",
              width: "21",
              height: "2"
            }),
            _react2.default.createElement("rect", {
              id: "Rectangle-3-Copy-2",
              fillOpacity: "0.5",
              fill: "#96A9B2",
              x: "8",
              y: "10",
              width: "21",
              height: "2"
            }),
            _react2.default.createElement("rect", {
              id: "Rectangle-3-Copy-5",
              fillOpacity: "0.5",
              fill: "#96A9B2",
              x: "8",
              y: "14",
              width: "21",
              height: "2"
            }),
            _react2.default.createElement("rect", {
              id: "Rectangle-3-Copy-7",
              fillOpacity: "0.5",
              fill: "#96A9B2",
              x: "8",
              y: "18",
              width: "13",
              height: "2"
            }),
            _react2.default.createElement("rect", {
              id: "Rectangle-3-Copy",
              fillOpacity: "0.5",
              fill: "#96A9B2",
              x: "3",
              y: "6",
              width: "3",
              height: "2"
            }),
            _react2.default.createElement("rect", {
              id: "Rectangle-3-Copy-3",
              fillOpacity: "0.5",
              fill: "#96A9B2",
              x: "3",
              y: "10",
              width: "3",
              height: "2"
            }),
            _react2.default.createElement("rect", {
              id: "Rectangle-3-Copy-4",
              fillOpacity: "0.5",
              fill: "#96A9B2",
              x: "3",
              y: "14",
              width: "3",
              height: "2"
            }),
            _react2.default.createElement("rect", {
              id: "Rectangle-3-Copy-6",
              fillOpacity: "0.5",
              fill: "#96A9B2",
              x: "3",
              y: "18",
              width: "3",
              height: "2"
            }),
            _react2.default.createElement("rect", {
              id: "Rectangle-2",
              fill: "#42A5FC",
              x: "0",
              y: "0",
              width: "32",
              height: "4"
            }),
            _react2.default.createElement("circle", {
              id: "Oval-2",
              fill: "#FFFFFF", cx: "28.5", cy: "20.5", r: "7.5"
            }),
            _react2.default.createElement(
              "g",
              {
                id: "Fill-1"
              },
              _react2.default.createElement("use", {
                fill: "#42A5FC",
                fillRule: "evenodd",
                xlinkHref: "#path-1"
              }),
              _react2.default.createElement("path", {
                stroke: "#FFFFFF",
                strokeWidth: "2",
                d: "M31.5153377,20.8342292 L31.5153388,20.8335767 \n                  C31.5189189,18.9951317 30.0256419,17.4983411 28.1784306,17.4923724 \n                  C26.333741,17.48522 24.8280282,18.9826123 24.8244468,20.8275264 \n                  C24.8220596,22.6651121 26.3160207,24.1622181 28.1629059,24.169379 \n                  C30.0070815,24.1765294 31.5129499,22.6782445 31.5153377,20.8342292 Z \n                  M24.4683924,27.7136747 L19.7605376,32.4140012 L19.0539966,31.706753 \n                  C18.4586663,31.1108269 17.8773079,30.5303981 17.2944022,29.9499723 \n                  L16.5840747,29.2426668 L17.2930951,28.5340511 C17.9203759,27.9071285 \n                  20.1244489,25.7064717 21.2844716,24.5478394 C20.5992029,23.2900252 \n                  20.2861689,21.9207882 20.3516479,20.4654328 C20.4969659,17.2180233 \n                  22.6313837,14.3921036 25.7161511,13.419152 C28.7423092,12.4633038 \n                  31.5153543,13.150683 33.788733,15.3992966 C34.934011,16.5340412 \n                  35.6343973,17.9608497 35.9069655,19.6284166 C35.9246779,19.7401477 \n                  35.9392564,19.8512244 35.9558692,19.9941212 C35.9633933,20.0594862 \n                  35.9633933,20.0594862 35.9705048,20.1224819 C35.9816139,20.2207605 \n                  35.9816139,20.2207605 35.9925805,20.3126241 L36,20.4342132 L36,21.2275382 \n                  L35.9913431,21.3588348 C35.9830859,21.4211805 35.9769216,21.4707079 \n                  35.9624484,21.5894972 C35.9599959,21.6096331 35.9599959,21.6096331 \n                  35.9575158,21.6299617 C35.9417414,21.7591587 35.9312602,21.8411797 \n                  35.9186723,21.9306268 C35.7106126,23.3953679 35.1263479,24.7079733 \n                  34.1791852,25.8360199 C33.1224847,27.0984564 31.7966382,27.9534564 \n                  30.2275734,28.3688577 C28.2144413,28.9017032 26.274203,28.6780579 \n                  24.4683924,27.7136747 Z"
              })
            )
          )
        )
      )
    )
  );
};

exports.default = SearchDiscover;


//////////////////
// WEBPACK FOOTER
// ./~/@surfline/quiver-react/dist/IntroModal/SearchDiscoverIcon.js
// module id = 598
// module chunks = 11